"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DBErrorExtractor", {
    enumerable: true,
    get: function() {
        return DBErrorExtractor;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _pgextractor = require("./pg.extractor");
const _sqliteextractor = require("./sqlite.extractor");
const _mysqlextractor = require("./mysql.extractor");
const _defaultextractor = require("./default.extractor");
let DBErrorExtractor = class DBErrorExtractor {
    static get() {
        return DBErrorExtractor._;
    }
    detectClientType(error) {
        if (!(error == null ? void 0 : error.code)) return null;
        const code = String(error.code);
        // MySQL: errors start with ER_
        if (code.startsWith('ER_')) return _nocodbsdk.ClientType.MYSQL;
        // PostgreSQL: 5-character SQLSTATE codes
        if (/^[0-9A-Z]{5}$/.test(code)) return _nocodbsdk.ClientType.PG;
        // SQLite: errors start with SQLITE_
        if (code.startsWith('SQLITE_')) return _nocodbsdk.ClientType.SQLITE;
        return null;
    }
    extractDbError(error, option) {
        var _ref;
        const clientType = (_ref = option == null ? void 0 : option.clientType) != null ? _ref : this.detectClientType(error);
        let extractResult;
        if (clientType) {
            var _this_extractors_get;
            extractResult = (_this_extractors_get = this.extractors.get(clientType)) == null ? void 0 : _this_extractors_get.extract(error);
        } else {
            [
                _nocodbsdk.ClientType.PG,
                _nocodbsdk.ClientType.MYSQL,
                _nocodbsdk.ClientType.SQLITE
            ].forEach((ct)=>{
                if (!extractResult) {
                    var _this_extractors_get;
                    extractResult = (_this_extractors_get = this.extractors.get(ct)) == null ? void 0 : _this_extractors_get.extract(error);
                }
            });
        }
        if (!extractResult && !(option == null ? void 0 : option.ignoreDefault)) {
            extractResult = this.defaultExtractor.extract(error);
        }
        return extractResult;
    }
    constructor(){
        this.logger = new _common.Logger('MissingDBError');
        this.extractors = new Map([
            [
                _nocodbsdk.ClientType.PG,
                new _pgextractor.PgDBErrorExtractor({
                    dbErrorLogger: this.logger
                })
            ],
            [
                _nocodbsdk.ClientType.SQLITE,
                new _sqliteextractor.SqliteDBErrorExtractor({
                    dbErrorLogger: this.logger
                })
            ],
            [
                _nocodbsdk.ClientType.MYSQL,
                new _mysqlextractor.MysqlDBErrorExtractor({
                    dbErrorLogger: this.logger
                })
            ]
        ]);
        this.defaultExtractor = new _defaultextractor.DefaultDBErrorExtractor({
            dbErrorLogger: this.logger
        });
    }
};
DBErrorExtractor._ = new DBErrorExtractor();
